export const API_URL = "https://cms.attivaasportswear.net/api";
export const API_URL2 = "https://cms.attivaasportswear.net/";
export const AUTH_TOKEN = "API-3da22c0dc082b5ca8bdde2b1a148bb5328f0f7c8";
export const BEARER = "Bearer";
